import { useEffect, useState } from 'react'
import { search } from '../application/search'
import { searchDataPort } from '../wiring'
import type { SearchResult } from '../domain/search'

const DEBOUNCE_MS = 200

const useSearchResults = (term: string, enabled: boolean) => {
	const [results, setResults] = useState<SearchResult[]>([])
	const [isLoading, setIsLoading] = useState(false)

	useEffect(() => {
		if (!enabled) {
			setResults([])
			setIsLoading(false)
			return
		}

		let cancelled = false
		const timeout = window.setTimeout(() => {
			setIsLoading(true)
			void search(searchDataPort, { term })
				.then(next => {
					if (!cancelled) setResults(next)
				})
				.finally(() => {
					if (!cancelled) setIsLoading(false)
				})
		}, DEBOUNCE_MS)

		return () => {
			cancelled = true
			window.clearTimeout(timeout)
		}
	}, [term, enabled])

	return { results, isLoading }
}

export { useSearchResults }
